import { Stack } from '@mui/material';
import { FilterField } from './FilterField';

export function ExternalPersonFilter({
  value = {},
  onChange,
  filterValues = {},
}) {
  const handleFilterChange = (field) => (event, update) => {
    onChange({
      ...value,
      [field]: update,
    });
  };

  return (
    <Stack spacing={1} sx={{ maxHeight: 238, overflow: 'scroll', pt: 0.75 }}>
      <FilterField
        label="Staff #"
        value={value.staffNumber}
        onChange={handleFilterChange('staffNumber')}
        options={filterValues['properties.code'] ?? []}
      />
      <FilterField
        label="Collar #"
        value={value.collarNumber}
        onChange={handleFilterChange('collarNumber')}
        options={filterValues['properties.collarNumber'] ?? []}
      />
      <FilterField
        label="Category"
        value={value.category}
        onChange={handleFilterChange('category')}
        options={filterValues['properties.category'] ?? []}
      />
      <FilterField
        label="Role"
        value={value.role}
        onChange={handleFilterChange('role')}
        options={filterValues['properties.role'] ?? []}
      />
    </Stack>
  );
}
